import { useContext } from "react";
import { useLocation } from "react-router-dom";
import { usePlatforms } from "../../../../../hooks/usePlatforms";
import ModalContext from "../../../../../contexts/modal";
import { translate, getPropertyPackagesStatus } from "../../../../../utils/Common";
import ContentCard from "../../../../../components/layout/ContentCard";
import Input from "../../../../../components/common/Input";
import Button from "../../../../../components/common/Button";
import Badge from "../../../../../components/common/Badge";
import { FaDoorOpen } from "react-icons/fa";
import styles from "./OpenLockerCard.module.css";
import { verifyAccessViewPermissions } from "../../../../../config/permissions";


const LockerCard = ({ pachageInfo }) => {
  const modalContext = useContext(ModalContext)
  const location = useLocation();
  const permissionsPath = "/dashboard/platforms/support";
  const canOpenDoor = verifyAccessViewPermissions(["open-door"], { path: permissionsPath });

  const { openLocker } = usePlatforms();

  const handleConfirm = (data) => {
    if (!canOpenDoor) return;
    modalContext.confirm(
      translate("global.alert.attention"),
      translate("global.confirmOpenLocker"),
      [
        <button
          type="button"
          key={1}
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90"
          onClick={() => handleOpenLocker(data)}
        >{translate("global.accept")}</button>,
        <button
          type="reset"
          key={2}
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs border border-secondary bg-transparent text-secondary hover:bg-secondary hover:text-secondary-foreground"
          onClick={() => modalContext.setIsOpenModal(false)}
        >
          {translate("global.cancel")}
        </button>,
      ],
      true
    );
  };

  const handleOpenLocker = async () => {
    try {
      if (!canOpenDoor) return;
      let dataToSend = {}
      dataToSend.idUsuario = pachageInfo.IdUsuario;
      dataToSend.idPaquete = pachageInfo.IdPaquete;
      dataToSend.idPlataforma = pachageInfo.IdPlataforma;
      const response = await openLocker(dataToSend);
      if (response.message === "OPENED_SUCCESSFULLY") {
        modalContext.confirm('¡Listo!',
          <span>{translate("dashboard.platforms.support.openLockerCard.OPENED_SUCCESSFULLY")}</span>,
          <button type="button" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs border border-secondary bg-transparent text-secondary hover:bg-secondary hover:text-secondary-foreground" onClick={() => modalContext.setIsOpenModal(false)}>{translate("global.accept")}</button>,
          true);
      }
    } catch (error) {
      modalContext.confirm(translate("global.alerts.ops"),
        <span>{translate("dashboard.platforms.support.openLockerCard.ERROR_OPENING_LOCKER")}</span>,
        <button type="button" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90" onClick={() => modalContext.setIsOpenModal(false)}>{translate("global.accept")}</button>,
        true);
      console.log(error);
    }
  }

  const statusInfo = pachageInfo?.IdEstatus != null ? getPropertyPackagesStatus(pachageInfo.IdEstatus) : null;

  const hexToRgba = (hex, alpha = 0.15) => {
    if (!hex || typeof hex !== 'string') return 'var(--bg-tertiary)';
    const clean = hex.replace('#', '');
    const match = clean.match(/^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/);
    if (!match) return 'var(--bg-tertiary)';
    const r = parseInt(match[1], 16);
    const g = parseInt(match[2], 16);
    const b = parseInt(match[3], 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };

  return (
    <div className={styles.cardsRow}>
      <div className={styles.cardWrapper}>
        <ContentCard
          title={translate("dashboard.platforms.support.openLockerCard.title")}
          padding="md"
        >
          <div className={styles.fieldsGrid}>
            <div className={styles.fieldCol5}>
              <Input
                label={translate("global.numPackage")}
                value={pachageInfo.Nro_Id ?? ''}
                disabled
                size="md"
              />
            </div>
            <div className={styles.fieldCol3}>
              <Input
                label={translate("global.key")}
                value={pachageInfo.Clave ?? ''}
                disabled
                size="md"
              />
            </div>
            <div className={styles.fieldCol4}>
              {statusInfo ? (
                <div>
                  <span className={styles.fieldLabel}>{translate("global.state")}</span>
                  <Badge
                    variant="neutral"
                    icon={statusInfo.icon}
                    showIcon={!!statusInfo.icon}
                    style={{
                      color: statusInfo.color || 'var(--text-secondary)',
                      backgroundColor: hexToRgba(statusInfo.color),
                      borderColor: statusInfo.color ? hexToRgba(statusInfo.color, 0.4) : 'var(--border-light)',
                    }}
                  >
                    {statusInfo.text || pachageInfo.Estatus}
                  </Badge>
                </div>
              ) : (
                <Input
                  label={translate("global.state")}
                  value={pachageInfo.Estatus ?? ''}
                  disabled
                  size="md"
                />
              )}
            </div>
            <div className={styles.fieldCol8}>
              <Input
                label={translate("global.client")}
                value={pachageInfo.Cliente ?? ''}
                disabled
                size="md"
              />
            </div>
            <div className={styles.fieldCol4}>
              <Input
                label={`Id ${translate("global.client")}`}
                value={pachageInfo.IdCliente ?? ''}
                disabled
                size="md"
              />
            </div>
            {pachageInfo.PackageIdGL && (
              <div className={styles.fieldCol6}>
                <Input
                  label={translate("global.reservationId")}
                  value={pachageInfo.PackageIdGL ?? ''}
                  disabled
                  size="md"
                />
              </div>
            )}
            {pachageInfo.IdReserva && (
              <div className={styles.fieldCol6}>
                <Input
                  label={translate("global.locationId")}
                  value={pachageInfo.DescPlataforma ?? ''}
                  disabled
                  size="md"
                />
              </div>
            )}
          </div>
        </ContentCard>
      </div>
      <div className={styles.cardWrapper}>
        <ContentCard
          title={translate("dashboard.platforms.support.openLockerCard.dataLocker")}
          padding="md"
        >
          <div className={styles.fieldsGrid}>
            <div className={styles.fieldCol6}>
              <Input
                label={translate("global.locker")}
                value={pachageInfo.Plataforma ?? ''}
                disabled
                size="md"
              />
            </div>
            <div className={styles.fieldCol6}>
              <Input
                label={`${translate("global.locker")} Id`}
                value={pachageInfo.IdPlataforma ?? ''}
                disabled
                size="md"
              />
            </div>
            {pachageInfo.DescPlataforma && (
              <div className={styles.fieldCol6}>
                <Input
                  label={translate("dashboard.platforms.support.openLockerCard.locationId")}
                  value={pachageInfo.DescPlataforma}
                  disabled
                  size="md"
                />
              </div>
            )}
            <div className={styles.fieldCol6}>
              <Input
                label={translate("global.numDoor")}
                value={pachageInfo.Identificacion ?? translate("global.notAssigned")}
                disabled
                size="md"
              />
            </div>
            <div className={styles.fieldCol6}>
              <Input
                label={`${translate("global.door")} Id`}
                value={pachageInfo.IdPlataformaDet ?? translate("global.notAssigned")}
                disabled
                size="md"
              />
            </div>
            <div className={styles.fieldCol12}>
              <div className={styles.actionsSection}>
                <Button
                  variant="primary"
                  size="md"
                  leftIcon={<FaDoorOpen size={14} />}
                  onClick={() => handleConfirm()}
                  disabled={!canOpenDoor || !pachageInfo.IdPlataformaDet}
                  aria-label={translate("dashboard.platforms.support.openLockerCard.openDoor")}
                >
                  {translate("dashboard.platforms.support.openLockerCard.openDoor")}
                </Button>
                {!pachageInfo.IdPlataformaDet && (
                  <span className={styles.assignDoorMessage}>
                    {translate("dashboard.platforms.support.openLockerCard.asignDoor")}
                  </span>
                )}
              </div>
            </div>
          </div>
        </ContentCard>
      </div>
    </div>
  );
}

export default LockerCard;